module.exports = {
	"classes": [
		"passwordless-page",
		"header-dark"
	],
	"title": "Passwordless: SMS Login and Email Authentication",
	"metas": {
		"description": "Get started with Passwordless. Token-based authentication to replace passwords. SMS Login and Email Authentication service."
	},
	"opengraph": {
		"og:title": "Passwordless: SMS Login and Email Authentication",
		"og:description": "Get started with Passwordless. Token-based authentication to replace passwords. SMS Login and Email Authentication service.",
		"og:url": "https://auth0.com/passwordless",
		"og:image": "http://cdn2.auth0.com/blog/passwordless/social-card.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/passwordless/social-card.png"
	},
	"twittercard": {
		"twitter:title": "Passwordless: SMS Login and Email Authentication",
		"twitter:description": "Get started with Passwordless. Token-based authentication to replace passwords. SMS Login and Email Authentication service.",
		"twitter:image": [
			{
				"src": "http://cdn2.auth0.com/blog/passwordless/social-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/passwordless/metadata.json
// module id = 1426
// module chunks = 0